module.exports = __webpack_public_path__ + "img/boundingbox_cn.7a7d11e.jpg";